import { THEME } from "@/config/theme";

// ── Edge arrowheads (design mock `tt-arrow`) ─────────────────────────────────
// The mock draws a thin OPEN chevron at the edge head — `fill:none`, indigo
// stroke — not React Flow's default filled `ArrowClosed` triangle. We define the
// SVG <marker>s once in the document (marker url() refs resolve globally) and
// point edges at them via EDGE_MARKER_ID / EDGE_MARKER_START_ID.
//
// Two markers, same chevron:
//  - kf-arrow        orient="auto"               → the head at an edge's target end
//  - kf-arrow-start  orient="auto-start-reverse" → the head at a bidirectional
//                                                   edge's source end, flipped so
//                                                   it points OUT of the node.
// markerUnits is left at its default ("strokeWidth") so the head scales with the
// line, matching the mock (idle 1.8 / active 2.4).
//
// IMPORTANT — these are BARE marker IDs, not `url(#…)` strings. React Flow takes
// an edge's `markerEnd`/`markerStart` string and wraps it itself as
// `url('#<id>')` (see getMarkerId in @xyflow/system). Passing a `url(#…)` string
// would double-wrap into `url('#url(#kf-arrow)')` and render no arrow. Set edge
// markers to these ids; RF does the wrapping.

// Each end has an IDLE and an ACTIVE variant so the arrowhead follows the same
// highlight as the line it terminates: a node selection / hand-mode peek brightens
// both. Colours + opacities mirror AnimatedEdge's line states (idle #4f46e5 @ .5,
// active #818cf8 @ .95) so the head reads as a seamless continuation of the line.
export const EDGE_MARKER_ID = "kf-arrow";
export const EDGE_MARKER_ACTIVE_ID = "kf-arrow-active";
export const EDGE_MARKER_START_ID = "kf-arrow-start";
export const EDGE_MARKER_START_ACTIVE_ID = "kf-arrow-start-active";

interface MarkerSpec { id: string; orient: string; color: string; opacity: number }

const MARKERS: MarkerSpec[] = [
  { id: EDGE_MARKER_ID,              orient: "auto",               color: THEME.raw.edgeStroke,         opacity: THEME.raw.edgeOpacity },
  { id: EDGE_MARKER_ACTIVE_ID,       orient: "auto",               color: THEME.raw.edgeStrokeSelected, opacity: THEME.raw.edgeOpacitySelected },
  { id: EDGE_MARKER_START_ID,        orient: "auto-start-reverse", color: THEME.raw.edgeStroke,         opacity: THEME.raw.edgeOpacity },
  { id: EDGE_MARKER_START_ACTIVE_ID, orient: "auto-start-reverse", color: THEME.raw.edgeStrokeSelected, opacity: THEME.raw.edgeOpacitySelected },
];

export function EdgeMarkers() {
  return (
    <svg aria-hidden width="0" height="0" style={{ position: "absolute", pointerEvents: "none" }}>
      <defs>
        {MARKERS.map((m) => (
          <marker
            key={m.id}
            id={m.id}
            markerWidth="9"
            markerHeight="9"
            refX="7"
            refY="4.5"
            orient={m.orient}
          >
            <path
              d="M1,1 L8,4.5 L1,8"
              fill="none"
              stroke={m.color}
              strokeOpacity={m.opacity}
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </marker>
        ))}
      </defs>
    </svg>
  );
}
